export const orderTypeJa = {
  delivery: 'オードブル',
  catering: 'ケータリング',
}
 export const mealTypeJa = {
   finger: 'フィンガー',
   buffet: 'ビュッフェ',
   subdivision: '小分け盛り',
 }
